import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Box, Flex } from '../grid';
import { Icon } from '../icons';
import { P } from '../typography/new';

const StyledButton = styled(Flex)`
  ${({ $isSelected, theme }) =>
    $isSelected &&
    `
    border-color: ${theme.colors.black};
    background-color: ${theme.colors.white};
    border-radius: 8px;
  `}
`;

const SelectableButton = ({ iconName, onClick, isSelected, isDisabled, children, ...rest }) => (
  <StyledButton
    disabled={isDisabled}
    $isSelected={isSelected}
    borderRadius="8px"
    as="button"
    type="button"
    cursor={isDisabled ? 'not-allowed' : 'pointer'}
    alignItems="center"
    justifyContent="center"
    border="1px solid"
    height={{ xs: '117px', md: '135px' }}
    flex="1"
    borderColor="warmWhite5"
    width="100%"
    variant="selectable"
    onClick={onClick}
    {...rest}
    px={0}
    opacity={isDisabled ? 0.7 : 1}
  >
    <Flex flexDirection="column" justifyContent="center" alignItems="center" gap="12px">
      {iconName && (
        <Box>
          <Icon name={iconName} outline="black" height="40px" width="40px" />
        </Box>
      )}

      <Flex flexDirection="column" alignItems="center">
        <P textTransform="none" color="black" variant="small-semi-bold">
          {children}
        </P>
        {isDisabled && (
          <P textTransform="none" color="black" variant="extra-small">
            Unavailable
          </P>
        )}
      </Flex>
    </Flex>
  </StyledButton>
);

SelectableButton.propTypes = {
  iconName: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  isSelected: PropTypes.bool,
  isDisabled: PropTypes.bool,
  children: PropTypes.node,
};

SelectableButton.defaultProps = {
  iconName: null,
  isSelected: false,
  isDisabled: false,
  children: null,
};

export { SelectableButton };
